// ./Components/WelcomeMessages/GenricCollectionMessage.js


import React from "react";

const GenricCollectionMessage = props => (
  <div className="alert alert-primary d-flex justify-content-between align-items-center py-2" role="alert">
    <span>{props.tipDescrption}</span>
    <span onClick={props.GenricCollectionMessageClose} className="ml-3" style={{ cursor: 'pointer', flexShrink: 0 }}>
      <i className="far fa-times-circle" />
    </span>
  </div>
);

export default GenricCollectionMessage;
